/**
 * Client-side gates for Reporting & Intelligence UI.
 * Fail closed. Do not authorize — server still 404s when master flag is off.
 */

function parseEnvFlag(value) {
  return String(value || 'false').trim().toLowerCase() === 'true';
}

/** @returns {boolean} */
export function isReportingIntelligenceUiEnabled() {
  return parseEnvFlag(process.env.REACT_APP_REPORTING_INTELLIGENCE_ENABLED);
}

/**
 * Opt-in fixture compose. Live AnalyticsProvider / CAD is the default.
 * Never silently fall back to fixtures when this is false.
 * @returns {boolean}
 */
export function isReportingIntelligenceFixturesEnabled() {
  return parseEnvFlag(process.env.REACT_APP_REPORTING_INTELLIGENCE_USE_FIXTURES);
}
